/**
 * What the demo on a computer tells the till: `npm run demo` in the root starts Vite with these. The
 * built till (and the Tafo app for Windows) has neither.
 */

/** When the demo started: a demo that starts again is the program that starts again (Opening). */
export function demoStart(): string | undefined {
  const start = import.meta.env.DEV ? import.meta.env.VITE_DEMO_START : undefined;
  return start === undefined || start === "" ? undefined : start;
}

/**
 * In the demo the till carries the address the demo opens ("/#kassa"), however it was opened. On a Mac,
 * a start of the demo brings back the tab that still shows that address and reloads it, rather than
 * opening one more: the mark tells the till apart from the other pages of the demo. Without it the demo
 * could come back with the customer's page of an order of the demo before ("Deze link werkt niet
 * meer") and no till at all (Furkan, 03/10/2026).
 */
export function markDemoTill(location: Location = window.location, history: History = window.history): void {
  const address = import.meta.env.DEV ? import.meta.env.VITE_DEMO_TILL : undefined;
  // only an address of the till itself
  if (!address?.startsWith("/")) return;
  if (`${location.pathname}${location.search}${location.hash}` === address) return;
  history.replaceState(history.state, "", address);
}

/**
 * "☎ Test oproep" is no button of a real till (Furkan, 05/10/2026: "die knop moet er helemaal niet zijn"):
 * a till that is built, the one of app.tafo.be and of the Tafo app for Windows, never shows it. The demo on a
 * computer has no telephone line, so there the button stays, to show what a call does.
 */
export function testCallOffered(): boolean {
  return import.meta.env.DEV;
}
